module.exports = __webpack_public_path__ + "static/img/dgf2.cb7323d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/dgf2.jpg
// module id = GxG2
// module chunks = 0